module.exports = {"Kanban":"Kanban","Kitting":"Kitting","Packaging":"Packaging","Process Docs":"Process Docs","Testing":"Testing"}


//////////////////
// WEBPACK FOOTER
// ./src/config/machiningServices.json
// module id = 5416
// module chunks = 1